<template>
    <div>
        Hello
    </div>
</template>

<script>
    export default {
        name: "home-page"
    }
</script>

<style scoped>

</style>